import { isApiMocked } from '@/lib/env'
import { apiClient } from '@/lib/api-client'
import type { GetSessionsListResponse, SessionSummary } from '../types'

export async function fetchSessionList(): Promise<GetSessionsListResponse> {
  if (isApiMocked) {
    const sessions = (await import('$data/mock/sessions.json')).default as SessionSummary[]
    return { sessions }
  }
  return apiClient.get<GetSessionsListResponse>('/get_sessions_list')
}
